import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const datetime = this.element.dataset.datetime
    if (!datetime) return
    
    const date = new Date(datetime)
    
    // Format just the time: "10:11 PM"
    const options = {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }
    
    this.element.textContent = date.toLocaleTimeString('en-US', options)
  }
}